import React,{ useEffect } from "react";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import CourseEdit from "./Components/CourseEdit";
import Loader from "./Components/Loader";

const CourseEditPage=()=>{
    useEffect(()=>{
        document.title="Edit Service | Janushree"
      },[]);

      return(
        <>
            <Header/>
                <CourseEdit/>
                <Loader/>
            <Footer/>
        </>
    );
}

export default CourseEditPage;